import { FhsAxios } from "../../services/axios";
import Vue from "vue";

export default {
  state: {
    clients: []
  },
  mutations: {
    setClientsList: (state, payload) => {
      let list = Object.entries(payload).map(item => {
        return {
          value: item[0],
          text: item[1]
        };
      });
      state.clients = list;
    }
  },
  getters: {
    getClientList: state => state.clients || []
  },
  actions: {
    changeSelectedClient({}, payload) {
      return FhsAxios.post("user/update-client-id", {
        client_id: payload
      });
    },
    fetchClientOptionList({ commit }) {
      commit("setClientsList", []);
      FhsAxios.get("user/client-id-list").then(res => {
        if (res.data.status) {
          commit("setClientsList", res.data.result);
        }
      });
    }
  }
};
